export class AppConsts {

    static readonly tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';

    static remoteServiceBaseUrl: string;
    static appBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'Ecommerce'
    };

    static readonly authorization = {
        encryptedAuthTokenName: 'enc_auth_token'
    };


    static readonly permissions = {
        Pages_ApprovedVerifyInfoOrder: 'Pages.ApprovedVerifyInfoOrder', // duyệt thông tin đơn
        Pages_DeleteOrder: 'Pages.DeleteOrder', // Xóa đơn hàng
        Pages_CancelledOrder: 'Pages.CancelledOrder', // hủy đơn hàng
        Pages_CreateSeriOrder: 'Pages.CreateSeriOrder', // tạo số seri
        Pages_CreateContract: 'Pages.CreateContract', // tạo hợp đồng
        Pages_SignContract: 'Pages.SignContract', // ký hợp đồng
        Pages_ApprovedContract: 'Pages.ApprovedContract', // duyệt hợp đồng
        Pages_PaymentFirst: 'Pages.PaymentFirst', // thanh toán lần đầu
        Pages_ApprovedPaymentFist: 'Pages.ApprovedPaymentFist', // duyệt thanh toán lần đầu
        Pages_UploadInfoDevice: 'Pages.UploadInfoDevice', // chờ khóa máy, thêm thông tin icloud
        Pages_ApprovedDevice: 'Pages.ApprovedDevice', // duyệt khóa máy
        Pages_UploadInfoHandOver: 'Pages.UploadInfoHandOver', // upload biên bản bàn giao
        Pages_ApprovedUploadInfoHandOver:'Pages.ApprovedUploadInfoHandOver', //phê duyệt biên bản bàn giao
        Pages_UpdateCurrentlyRenting: 'Pages.UpdateCurrentlyRenting', // cập nhật trạng thái đang thuê
        Pages_ApprovedTransaction: 'Pages.ApprovedTransaction', // phê duyệt giao dịch
        Pages_RejectTransaction: 'Pages.RejectTransaction', // từ chối giao dịch
        Pages_RejectConfirm: 'Pages.RejectConfirm', // từ chối xác nhận
        Pages_EditOrder: 'Pages.EditOrder', // sửa đơn hàng
        Pages_ViewProfitTransaction: 'Pages.ViewProfitTransaction', // xem lợi nhuật giao dịch
        Pages_ResendContractOrder: 'Pages.ResendContractOrder', // Gửi lại hợp đồng
        Pages_NoteOrder: 'Pages.NoteOrder', // ghi chú đơn hàng
        Pages_UploadNoteOrder: 'Pages.UploadNoteOrder', // tải lên thông tin ghi chú đơn hàng
        Pages_ApprovedDeviceOld: 'Pages.ApprovedDeviceOld', // tải lên thông tin ghi chú đơn hàng
        Pages_AssignOrderEmployee: 'Pages.AssignOrderEmployee', // tải lên thông tin ghi chú đơn hàng
        Pages_FinalSettlementOrder: 'Pages.FinalSettlementOrder', // tất toán đơn hàng
        Pages_RequestForSettlement: 'Pages.RequestForSettlement', // yêu cầu tất toán
        Pages_Stores: 'Pages.Stores', // cửa hàng
        Pages_Stores_Create: 'Pages.Stores.Create', // thêm cửa hàng
        Pages_Stores_Edit: 'Pages.Stores.Edit', // sửa cửa hàng
        Pages_Stores_Delete: 'Pages.Stores.Delete', // xóa cửa hàng
    };
}
